<div class="visibility-container">
  <div class="visibility-title">
    {{ 'TARGET-GROUP.TITLE' | translate }}
  </div>
  <div 
    class="visibility-text" 
    [innerHTML]="(isCourse 
        ? 'TARGET-GROUP.ELEARNING.TEXT' 
        : 'TARGET-GROUP.TRAINING.TEXT'
      ) | translate
    "
  ></div>
  <dx-tabs
    width="100%"
    [selectedIndex]="visibilityMode"
    [showNavButtons]="false"
    [dataSource]="visibilityModes"
    (onItemClick)="onVisibilityModeChange($event)"
    [disabled]="isViewMode"
    class="visibility-tabs-container"
  ></dx-tabs>
  <div *ngIf="visibilityMode === EventVisibilityModeModel.Everyone">
    <div class="info-container visible-text-container">
      <i class="dx-icon dx-svg-icon" [innerHTML]="getClockIcon()"></i>
      <span [innerHTML]="getVisibleToEveryoneText()"></span>
    </div>
  </div>
  <div *ngIf="visibilityMode === EventVisibilityModeModel.Restricted">
    <div class="organization-units-container">
      <dx-drop-down-box
        [(value)]="organizationUnitIds"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
        [dataSource]="organizationUnits"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            [searchEnabled]="true"
            [dataSource]="organizationUnits"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="
              onOrganizationUnitsSelected($event)
            "
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    <div class="training-groups-container">
      <dx-drop-down-box
        [(value)]="trainingGroupIds"
        [inputAttr]="{ 'aria-label': 'Owner' }"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
        [dataSource]="trainingGroups"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
        [showClearButton]="true"
        (onValueChanged)="onTrainingGroupsValueChanged($event)"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            #trainingGroupsTree
            [searchEnabled]="true"
            [dataSource]="trainingGroups"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="
              onTrainingGroupSelected($event)
            "
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    <div class="roles-container" *ngIf="!isCourse">
      <dx-drop-down-box
        [(value)]="roleIds"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.ROLES' | translate"
        [dataSource]="roles"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
        [showClearButton]="true"
        (onValueChanged)="onRolesValueChanged($event)"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            #rolesTree
            [searchEnabled]="true"
            [dataSource]="roles"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="onRoleSelected($event)"
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    @if(isVisibleToEveryone) {
      <div class="info-container no-filters-container">
        <i class="dx-icon dx-svg-icon" [innerHTML]="getWarningIcon()"></i>
        <span 
          [innerHTML]="(isCourse 
              ? 'TARGET-GROUP.ELEARNING.NO-FILTERS-WARNING' 
              : 'TARGET-GROUP.TRAINING.NO-FILTERS-WARNING'
            ) | translate
          "
        ></span>
      </div>
    } @else {
      <div class="info-container employee-target-container">
        <i class="dx-icon dx-svg-icon" [innerHTML]="getTargetIcon()"></i>
        <span 
          [innerHTML]="getEmployeeVisibleInText()"
        ></span>
      </div>
    }
  </div>

  <div 
    *ngIf="isPrivatePublishing" 
    class="private-publish-training"
  >
    <div class="sharing-title-container">
      <div>
        <mat-slide-toggle
          [disabled]="isViewMode"
          [ngModel]="allowSharingWithSubscribers"
          (ngModelChange)="onAllowSharingWithSubscribersChanged($event)"
          class="req-toggle"
        ></mat-slide-toggle>
      </div>
      <div>
        <div class="sharing-title">
          <span>
            {{ 'TARGET-GROUP.PRIVATE-PUBLISH-TRAINING.TEXT' | translate }}
          </span>
          <span class="private-badge">
            {{ 'COMMON.PRIVATE' | translate }}
          </span>
        </div>
        <div class="sharing-description">
          {{ 'TARGET-GROUP.PRIVATE-PUBLISH-TRAINING.DESCRIPTION' | translate }}
        </div>
      </div>
    </div>
    <div *ngIf="allowSharingWithSubscribers">
      <div class="subscriber-selector">
        <app-subscriber-selector
          [isViewMode]="isViewMode"
          [subscriptionIds]="subscriptionIds"
          (subscriptionIdsChange)="subscriptionIdsChange.emit($event)"
          [subscribers]="subscribers"
        ></app-subscriber-selector>
      </div>

      <div class="standard-catalogue-container">
        <app-standard-catalogue-selector
          [isViewMode]="isViewMode"
          [showTitle]="false"
          [standardTrainingCategories]="standardTrainingCategories"
          [standardTrainingCategoryIds]="standardTrainingCategoryIds"
          (standardTrainingCategoryIdsChange)="standardTrainingCategoryIdsChange.emit($event)"
          [usedStandardTrainingCategories]="usedStandardTrainingCategories"
        ></app-standard-catalogue-selector>
      </div>
    </div>
  </div>
</div>